<template><div>

    <a  @mouseover="handleFocus($event)">{{ handleLoad()}}</a>
    </div>
    </template>
  
 
<script>
export default {
  name: "ATips",
  props: ['str'],
   data() {
    return {         
      shortCutStr:""
      
    };
  },
   methods: {  
          
           handleFocus(event)
           {
               if(this.str.split(",").length>1)
                event.currentTarget.title=this.str;          
          
           },
           handleLoad()
           {
              
               if(this.str.split(",").length>1)
               {
                   return this.str.split(",")[0]+"...";
               }  
               return this.str;
           }
          }
};
 
 
</script>


// WEBPACK FOOTER //
// src/components/shared/ATips.vue